import axios from 'axios'


export default {
    getLogo() {
        return axios.get('/logo/company')
    },
    getHomepage() {
        return axios.get('/category')
    },
    getCategory(categoryname) {
        return axios.get('/category', {
            params: {
                category_name: categoryname
            }
        })
    },
    getBooksummary(book_id) {
        return axios.get('/book', {
            params: {
                book_id: book_id,
                resource_type: "summary"
            }
        })
    },
    getBookpage(book_id, page_id) {
        return axios.get('/book', {
            params: {
                book_id: book_id,
                resource_type: "detail",
                page_id: page_id
            }
        })
    },
}